import React from 'react';
import {Switch,Route} from 'react-router-dom';
import Header from './Components/Header/Header';
import HeaderLinks from './Components/Header/HeaderLinks';
import Home from './Pages/Home';
import Resume from './Pages/Resume';
import Portfolio from './Pages/Portfolio';
import Contact from './Pages/Contact';
const App = (props) =>{
    const { ...rest } = props;
    return(
        <>
            <Header
        brand="Ankur Barve"
        rightLinks={<HeaderLinks />}
        fixed
        color=""
        changeColorOnScroll={{
          height: 400,
          color: "#31313a",
        }}
        {...rest}
      />
     <main style={{position:'relative',top:50}}>    
     <Switch>
          <Route exact path="/" component={Home}/>
          <Route path="/resume" component={Resume}/>
          <Route path="/portfolio" component={Portfolio}/>
          <Route path="/contact" component={Contact}/>
      </Switch>
     </main>
    </>
    )
}
export default App;